import { TODAY } from "@/data/mock";
import { rate, pct, visibleTasks } from "@/lib/selectors";

export const STATUS = {
  pendente: { label: "Pendente", tone: "muted" },
  andamento: { label: "Em andamento", tone: "gold" },
  aguardando: { label: "Aguardando aprovação", tone: "dark" },
  concluida: { label: "Concluída", tone: "green" },
};
export const FREQ = { diaria: "Diária", semanal: "Semanal", mensal: "Mensal", pontual: "Pontual" };
export const METRICS = { tarefas: "Conclusão de tarefas (%)", checklists: "Checklists completos (%)", manual: "Indicador com resultado manual" };

export const isOverdue = (t) => (t.status === "pendente" || t.status === "andamento") && t.dueDate < TODAY;

export { visibleTasks } from "@/lib/selectors";

export const taskStats = (tasks) => {
  const done = tasks.filter((t) => t.status === "concluida").length;
  return {
    total: tasks.length,
    done,
    pct: tasks.length ? Math.round((done / tasks.length) * 100) : 0,
    overdue: tasks.filter(isOverdue).length,
    open: tasks.filter((t) => t.status === "pendente" || t.status === "andamento").length,
    awaiting: tasks.filter((t) => t.status === "aguardando").length,
  };
};

export const assigneeLabel = (t, names) => (t.collaboratorId ? names[t.collaboratorId] || "—" : t.teamRole === "*" ? "Toda a equipe" : `Equipe: ${t.teamRole}`);

export const sortTasks = (tasks) =>
  [...tasks].sort((a, b) => Number(isOverdue(b)) - Number(isOverdue(a)) || a.dueDate.localeCompare(b.dueDate) || a.time.localeCompare(b.time));

export const goalResult = (s, g) => {
  let value = Number(g.current) || 0;
  if (g.metric === "tarefas") {
    const c = s.collaborators.find((x) => x.id === g.collaboratorId);
    value = taskStats(c ? visibleTasks(s, c) : s.tasks.filter((t) => t.companyId === g.companyId)).pct;
  }
  if (g.metric === "checklists") {
    value = rate(s.checklists.filter((cl) => cl.companyId === g.companyId && (!g.collaboratorId || cl.collaboratorId === g.collaboratorId)).flatMap((cl) => cl.items));
  }
  return { value, att: pct(value, g.target) };
};
